export const behavioursMap = [
  {
    label: 'Radius',
    placeHolder: 'Radius Score',
  },
  {
    label: 'Acceleration',
    placeHolder: 'Acceleration Score',
  },
  {
    label: 'Braking',
    placeHolder: 'Braking Score',
  },
  {
    label: 'Turning',
    placeHolder: 'Turning Score',
  },
  {
    label: 'Speeding',
    placeHolder: 'Speeding Score',
  },
  {
    label: 'Accident',
    placeHolder: 'Accident Score',
  },
  {
    label: 'None',
    placeHolder: 'None Score',
  },
];

export const severityMap = [
  {
    label: 'Less than 33%',
    valueMap: 'SEVERITY_LESS_THAN_33_PERCENTAGE',
    placeHolder: '< 33%',
  },
  {
    label: '33% to 67%',
    valueMap: 'SEVERITY_BETWEEN_33_TO_67_PERCENTAGE',
    placeHolder: '33% to 67%',
  },
  {
    label: 'Greater than 67%',
    valueMap: 'SEVERITY_GREATER_THAN_67_PERCENTAGE',
    placeHolder: '> 67%',
  },
  {
    label: 'Speeding',
    valueMap: 'SEVERITY_SPEEDING',
    placeHolder: 'Speeding',
  },
  {
    label: 'Accident',
    valueMap: 'SEVERITY_ACCIDENT',
    placeHolder: 'Speeding',
  },
  {
    label: 'Hard',
    valueMap: 'SEVERITY_HARD',
    placeHolder: 'Hard',
  },
  {
    label: 'Harsh',
    valueMap: 'SEVERITY_HARSH',
    placeHolder: 'Harsh',
  },
  {
    label: 'Severe',
    valueMap: 'SEVERITY_SEVERE',
    placeHolder: 'Severe',
  },
  {
    label: 'None',
    valueMap: 'SEVERITY_NONE',
    placeHolder: 'None',
  },
];

export const initValues = {
  radius: '0',
  acceleration: '0',
  braking: '0',
  turning: '0',
  speeding: '0',
  accident: '0',
  none: '0',
  severity_less_than_33_percentage: '0',
  severity_between_33_to_67_percentage: '0',
  severity_greater_than_67_percentage: '0',
  severity_speeding: '0',
  severity_accident: '0',
  severity_hard: '0',
  severity_harsh: '0',
  severity_severe: '0',
  severity_none: '0',
};
